import { create } from "@/lib/create-safe-store";
import type { User } from "./types";

interface AuthState {
  user: User | null;
  needsChatProfile: boolean;
  setUser: (user: User | null) => void;
  setNeedsChatProfile: (needsChatProfile: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  needsChatProfile: false,
  setUser: (user) => set({ user }),
  setNeedsChatProfile: (needsChatProfile) => set({ needsChatProfile }),
}));
